module.exports = __webpack_public_path__ + "img/ic_design_item8.28db75a5.png";